module.exports = __webpack_public_path__ + "static/TakkHome-d5c7c2f50d31a6a76c66681594d1bfc8.png";